const taxEuArray = [
  "AX", "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI",
  "FR", "DE", "GR", "IE", "IT", "LV", "LT", "LU", "MT", "NL",
  "PL", "PT", "RO", "SK", "SI", "ES", "SE"
];

const taxNonEuArray = [
  "AL", "AD", "AZ", "BY", "BA", "FO", "GE", "GI", "HU", "IS",
  "IL", "JE", "MD", "MC", "ME", "MK", "QA", "SM", "SA", "RS",
  "SJ", "CH", "UA", "AE", "VA"
];

const vatMappings = [
  { rate: 1.23, mainVat: 'Ex Vat', subVat: 'Inc Vat', countries: taxEuArray },
  { rate: 0, mainVat: 'Ex Vat', subVat: '', countries:taxNonEuArray }
]

const mapping = vatMappings.find(c => c.countries.includes(userCountry));

export const vatRate = mapping ? mapping.rate : 0;
export const mainVat = mapping ? mapping.mainVat : '';
export const subVat = mapping ? mapping.subVat : '';